import React, { useContext } from 'react';
import { i18nContext } from '@/components/pages/assessments/context/i18n.context';
import { stepContext } from '@/components/pages/assessments/context/step.context';
import { displayContext } from '@/components/pages/assessments/context/display.context';
import AssessmentActions from '@/components/pages/assessments/AssessmentActions';
import { PREFER_NOT_TO_ANSWER } from './util';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '@/components/Button/Button';

const AssessmentReview = ({ answers, handleSaveAll }) => {
  const { t, xt } = useContext(i18nContext);
  const { css } = useContext(displayContext);
  const { assessment, handleRestart, goToQuestion, metadata } = useContext(stepContext);
  const buttons = metadata?.ui?.buttons || {};

  const jsx = () =>
    assessment.questions.map((q) => {
      const answerObj = answers[q.id] || {};
      let answer = answerObj.value;
      if (answer === null) answer = PREFER_NOT_TO_ANSWER;
      if (answer === undefined) return null; // i.e. the question was not asked
      if (Array.isArray(answer)) {
        answer = answer.map(t).join('; ');
      } else {
        answer = t(answer);
      }
      if (answer === '') answer = <em>{t('Skipped')}</em>;
      return (
        <li key={q.id} onClick={() => goToQuestion(q.id)} role="button" className={css('result-li', 'answer')}>
          <strong className={css('question-text')}>{q.question.public_label || q.question.label}</strong>
          <div>{answer}</div>
          <Button
            additionalClasses={`${css('edit-link')}`}
            type="link"
            shape="pill"
            text={t(buttons.edit || 'Edit')}
            onButtonClick={() => {}} // no click action needed as it is handled on the list item level
          />
        </li>
      );
    });

  return (
    <>
      <Row className={css('assessment-review')}>
        <Col>
          <Row className={css('assessment-body')}>
            <Col xs={12}>
              <Row className={css('assessment-review-panel')}>
                {metadata.review?.headline && (
                  <Col xs={12} className={css('assessment-review-headline')}>
                    {xt(metadata.review.headline)}
                  </Col>
                )}
                <Col xs={12} className={css('assessment-review-content')}>
                  <Row>
                    {metadata.review?.description && (
                      <Col xs={12} className={css('assessment-review-description')}>
                        {xt(metadata.review.description)}
                      </Col>
                    )}
                    <Col className={css('assessment-answer-list')}>
                      <ul>{jsx()}</ul>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col xs={12}>
              <AssessmentActions enableNext={true} handleNext={handleSaveAll} selection={null} buttonLabels={{ next: buttons.finish || 'Finish' }} />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default AssessmentReview;
